import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: true,
};

const adminConsoleSidebarSlice = createSlice({
  name: "adminConsoleSidebar",
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.open = true;
    },
    hide: (state) => {
      state.open = false;
    },
    toggle: (state) => {
      state.open = !state.open;
    },
  },
});

export const { show, hide, toggle } = adminConsoleSidebarSlice.actions;
export default adminConsoleSidebarSlice.reducer;
